import { styled } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles/createMuiTheme";

export const ConfigurationContainer = styled("div")(({ theme }: { theme: Theme }) => ({
    width: "100%",
    boxSizing: "border-box",
    padding: "24px 30px",

    backgroundColor: theme.palette.background.paper,
    borderRadius: "12px",
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)",

    "@media (max-width: 600px)": {
        padding: "16px",
        borderRadius: "8px",
    },
}));
